import { useWizard } from "react-use-wizard";
import buySteps from "../../buySteps";
import ViewRealtorParticipationStep from "../../../../../../../shared/wizard/steps/viewRealtorParticipationStep";
import { TKeyOfDataWizardBuy, TStringKeysOfIFillDataWizardBuy } from "../../..";
import { EDealRequestViewType } from "../../../../../../../shared/wizard/steps/types";

interface IWishSwapStepBuy_5 {
  onChange: (
    data: EDealRequestViewType,
    key: TStringKeysOfIFillDataWizardBuy
  ) => void;
  data: EDealRequestViewType | null;
  isNextStepDisabled: boolean;
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
}

const WishSwapStepBuy_5 = ({
  data,
  isNextStepDisabled,
  onChange,
  onReset,
}: IWishSwapStepBuy_5) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.wishesSteps.swap.step_4);
    onReset(["viewRealtorParticipation"]);
  };

  const handleNexStep = () => {
    goToStep(buySteps.wishesSteps.swap.step_6);
  };

  return (
    <div>
      <ViewRealtorParticipationStep
        handlePrevStep={handlePrevStep}
        handleNexStep={handleNexStep}
        onChange={onChange}
        isNextStepDisabled={isNextStepDisabled}
        data={data}
        mode="buy"
      />
    </div>
  );
};

export default WishSwapStepBuy_5;
